export default __webpack_public_path__ + "static/media/icon_error.958824f9.svg";